<div class="aftp-container">
  <ng-content></ng-content>
</div>
